import { useCallback, useEffect, useRef } from 'react';
import { ReusableModal } from '../modals/ReusableModal';
import { PointFilters } from './PointFilters';
import { PointsList } from './PointsList';
import { useDispatch } from 'react-redux';
import { advancedFiltersActions } from '../filters/advancedFiltersSlice';
import { LoadingIndicator } from '../helpers/LoadingIndicator';

/**
 * @typedef {{
 *  isOpen: import("../modals/ReusableModal").ReusableModalProps['isOpen'];
 *  onClose: import("../modals/ReusableModal").ReusableModalProps['onClose'];
 *  size?: import("../modals/ReusableModal").ReusableModalProps['size'];
 *  lockedTsps?: import("./PointFilters").PointFiltersProps['lockedTsps'];
 *  onSelect: import("./PointsList").PointListProps['onClick'];
 *  defaultFilters?: Record<string, any>;
 *  isLoading?: boolean;
 * }} PointSelectorModalProps
 */

/**
 *
 * @type {React.FC<PointSelectorModalProps>}
 */
export const PointSelectorModal = ({
  isOpen,
  onClose,
  size = 'lg',
  lockedTsps = [],
  onSelect,
  defaultFilters = {},
  isLoading = false,
}) => {
  /**
   * @type {React.RefObject<import("./PointFilters").PointFiltersRef | null>}
   */
  const filtersRef = useRef(null);

  const onSearch = useCallback(
    /**
     * @param {KeyboardEvent} e
     */
    (e) => {
      if (e.key === 'F3' || (e.ctrlKey && e.key === 'f')) {
        e.preventDefault();
        filtersRef.current?.focusSearchBox();
      }
    },
    [filtersRef],
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (isOpen && defaultFilters) {
      for (const [field, value] of Object.entries(defaultFilters)) {
        dispatch(
          advancedFiltersActions.setFilterValue({
            type: 'points',
            field,
            value,
          }),
        );
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('keydown', onSearch);
      return () => {
        window.removeEventListener('keydown', onSearch);
      };
    }
  }, [isOpen]);

  return (
    <ReusableModal isOpen={isOpen} onClose={onClose} size={size}>
      <div
        className="bg-light"
        style={{ position: 'sticky', top: '0', zIndex: 1 }}
      >
        <PointFilters lockedTsps={lockedTsps} ref={filtersRef} />
        <hr />
      </div>
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          <LoadingIndicator />
        </div>
      ) : (
        <div className="row d-flex flex-row-reverse">
          {/* <div className="col-6">
          <h3 className="text-center">Create point</h3>
          <PointForm />
        </div> */}
          <div className="col">
            <PointsList onClick={onSelect} />
          </div>
        </div>
      )}
    </ReusableModal>
  );
};
